import { LightBackgroundPage } from '@/shared/PublicPage/CustomBgPublicPage.styled';
import PublicPage from '@/shared/PublicPage/PublicPage';
import { Title } from '@/shared/Typography';
import { StyledBlog } from './Blog.styled';
import Dates from '@/constants/Dates';
import Image from 'next/image';
import dayjs from 'dayjs';
import Button from '@/shared/Button/Button';
import Link from 'next/link';
import utc from 'dayjs/plugin/utc';
dayjs.extend(utc);

export default function Blog({ blogItems }) {
  return (
    <PublicPage StyledPublicPage={LightBackgroundPage}>
      <StyledBlog>
        <Title className="title">Blog</Title>
        <div className="blog-items">
          {blogItems?.map((blogItem) => (
            <div className="blog-item" key={blogItem.id}>
              <div className="blog-title">
                <Title level={2}>{blogItem.title}</Title>
                <div className="blog-date">
                  {dayjs.utc(blogItem.createdAt).format(Dates.defaultFormat)}
                </div>
              </div>
              {blogItem.image ? (
                <div className="image-container">
                  <Image
                    src={blogItem.image}
                    alt={blogItem.title}
                    layout="fill"
                    objectFit="contain"
                  />
                </div>
              ) : null}
              {blogItem.shortDescription ? (
                <div
                  className="description"
                  dangerouslySetInnerHTML={{
                    __html: blogItem.shortDescription,
                  }}
                ></div>
              ) : null}
              <div className="read-more">
                <Link href={blogItem.slug} passHref>
                  <Button>Continue reading...</Button>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </StyledBlog>
    </PublicPage>
  );
}
